function AppName() {
    return (
        <>
            PonziDav
        </>
    );
}

export default AppName;